import React from "react";
import Navbarside from "../../component/Navbarside";
import Footer from "../footer";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/appUtils";

const LiveWell = () => {
  const dateForQuery = ()=>{
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const formattedToday = formatDate(today);
    const formattedOneMonthAgo = formatDate(oneMonthAgo);
    return {startDate:formattedToday, endDate:formattedOneMonthAgo}
  }
  return (
    <div>
      <Navbarside />
      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">

              <div className="row">

                <div className="col-xl-3 col-lg-3 col-md-6 col-12">
                  <Link to="/Enquiry?flow=liveWell&specific=1">
                    <div className="card bg-white">
                      <div className="card-body">
                        <div className="card-block pt-10 pb-10">
                          <div className="media">
                            <div className="media-body white text-left">
                              <h4 className="font-medium-2 card-title mb-0">
                                LiveWell Enquiry
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>


                <div className="col-xl-3 col-lg-3 col-md-6 col-12">
                  <Link to="/LiveWellCategory">
                    <div className="card bg-white">
                      <div className="card-body">
                        <div className="card-block pt-10 pb-10">
                          <div className="media">
                            <div className="media-body white text-left">
                              <h5 className="font-medium-2 card-title mb-0">
                                Category
                              </h5>
                            </div>
                            <div className="media-right text-right">
                              <i className="fas fa-user-tie fa-edit-icon success"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-12">
                  <Link to={`/SessionAnalysis?startDate=${dateForQuery().startDate}&&endDate=${dateForQuery().endDate}&&category=liveWell`}>
                    <div className="card bg-white">
                      <div className="card-body">
                        <div className="card-block pt-10 pb-10">
                          <div className="media">
                            <div className="media-body white text-left">
                              <h5 className="font-medium-2 card-title mb-0">
                                Session
                              </h5>
                            </div>
                            <div className="media-right text-right">
                              <i className="fas fa-chalkboard-teacher fa-edit-icon danger"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
              <div className="row">
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LiveWell;
